import { render, staticRenderFns } from "./MExamView.vue?vue&type=template&id=b2f2007e&"
import script from "./MExamView.vue?vue&type=script&lang=js&"
export * from "./MExamView.vue?vue&type=script&lang=js&"
import style0 from "./MExamView.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports